import { cn } from "../../../utils/useFunctions";
import AnalysisTableOne from "../component/analysisTable/analysisTableOne";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderText
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE
} from "../styles/pdf.style";

function PdfPageOverviewFour({
  page,
  balanceData
}) {

  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText />
     <AnalysisTableOne balanceData={balanceData} />
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOverviewFour;
